module.exports = __webpack_public_path__ + "media/images/flextab-favicon-7430796d218c895faba741da01fcdde9.png";